"use client";

import { c as _c } from "react/compiler-runtime";
import { Breadcrumbs as HeroBreadcrumbs } from "@heroui/react";
import { cn } from "../../lib/utils";
export const Breadcrumbs = t0 => {
  const $ = _c(13);
  let className;
  let itemClasses;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      itemClasses,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = itemClasses;
    $[3] = props;
  } else {
    className = $[1];
    itemClasses = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      item: "text-foreground",
      separator: "text-foreground"
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const defaultItemClasses = t1;
  let t2;
  if ($[5] !== itemClasses) {
    t2 = {
      ...defaultItemClasses,
      ...itemClasses
    };
    $[5] = itemClasses;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const mergedItemClasses = t2;
  let t3;
  if ($[7] !== className) {
    t3 = cn(className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== mergedItemClasses || $[10] !== props || $[11] !== t3) {
    t4 = <HeroBreadcrumbs className={t3} itemClasses={mergedItemClasses} {...props} />;
    $[9] = mergedItemClasses;
    $[10] = props;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};